import React from 'react';

import { NativeStackScreenProps } from '@react-navigation/native-stack';

import { CheckmarkLargeWhite } from '@/assets/icons/checkmark-large-white';
import { Button } from '@/components/ButtonComponent';
import BetrAnalytics from '@/feature/analytics/analytics';
import { AnalyticsEvent } from '@/feature/analytics/constants';
import { useProductTransitionStore } from '@/feature/product-transition/use-product-transition-store';
import { MaxWidthWrapper } from '@/feature/responsive-design/WebComponents';
import { useActiveWallet } from '@/hooks/use-active-wallet';
import { useJurisdictionStore } from '@/hooks/use-jurisdiction';
import { useRootNavigation } from '@/hooks/use-root-navigation';
import { popToHome } from '@/navigation/navigation';
import { WithdrawStackParamList } from '@/navigation/types';

import { ResultComponent } from '../components/ResultComponent';
import { WithdrawalFrame } from '../components/WithdrawalFrame';

type NavigationSuccessfulWithdrawalProps = NativeStackScreenProps<WithdrawStackParamList, 'SuccessfulWithdrawal'>;

export const SuccessfulWithdrawal = ({
    route: {
        params: { amountToWithdraw, methodType, title, description },
    },
}: NavigationSuccessfulWithdrawalProps) => {
    const rootNavigation = useRootNavigation();
    const product = useJurisdictionStore(state => state.product);
    const { activeWalletProduct } = useActiveWallet();
    const navigateToLobby = () => {
        BetrAnalytics.trackProductEvent(AnalyticsEvent.WITHDRAW_SUCCESS_DONE, { amountToWithdraw, methodType });

        //Switch to the active wallet's product lobby if wallet product is different from the current product
        if (product !== activeWalletProduct) {
            useProductTransitionStore.getState().actions.triggerTransition(activeWalletProduct);
            return;
        }

        popToHome(rootNavigation, 'lobby');
    };

    const onClose = () => {
        BetrAnalytics.trackProductEvent(AnalyticsEvent.WITHDRAW_SUCCESS_ABORT, { amountToWithdraw, methodType });
        popToHome(rootNavigation, 'account');
    };
    // terminal screen: it is pushed, but the icon dismisses the flow rather than going back
    return (
        <WithdrawalFrame showTitle={false} closeIconMode="close" onClose={onClose}>
            <MaxWidthWrapper flex={1}>
                <ResultComponent
                    textTitle={title}
                    textDescription={description}
                    resultIcon={<CheckmarkLargeWhite />}
                    footerItems={<Button label="Done" hierarchy={'primary'} onPress={navigateToLobby} />}
                />
            </MaxWidthWrapper>
        </WithdrawalFrame>
    );
};
